import i18n from '@/i18n'
import Papa from 'papaparse'

const BASE_KEY = 'documentSignatureCustomization.content.createChain.csv'

/**
 *
 * @param {string} csvText
 * @returns {Array<{filename: string, emails: string[]}>}
 * @throws {Error}
 */
export function parseCsvParticipants(csvText) {
  if (typeof csvText !== 'string' || csvText.trim().length === 0) {
    throw new Error(i18n.t(`${BASE_KEY}.empty`))
  }

  const parsed = Papa.parse(csvText, {
    delimiter: ';',
    skipEmptyLines: true
  })

  if (parsed.errors && parsed.errors.length > 0) {
    const firstErr = parsed.errors[0]
    throw new Error(
      i18n.t(`${BASE_KEY}.parseFailed`, { details: firstErr.message })
    )
  }

  const rows = parsed.data
  if (rows.length === 0) {
    throw new Error(i18n.t(`${BASE_KEY}.empty`))
  }

  let startIndex = 0
  const firstRow = rows[0]
  if (firstRow[0] && firstRow[0].toLowerCase() === 'filename') {
    startIndex = 1
  }

  const result = []

  for (let i = startIndex; i < rows.length; i++) {
    const row = rows[i]
    const cols = row.map((c) => (c ? c.trim() : '')).filter(Boolean)

    /* if (cols.length < 2) {
      throw new Error(
        i18n.t(`${BASE_KEY}.invalidRow`, { row: i + 1 })
      )
    } */
    if (cols.length < 1) {
      continue
    }

    const filename = cols[0]
    const emails = cols.length > 1 ? cols.slice(1) : []

    /* if (emails.length === 0) {
      throw new Error(
        i18n.t(`${BASE_KEY}.noEmails`, { row: i + 1 })
      )
    } */
    const invalidEmails = []
    const validEmails = []
    for (const em of emails) {
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)) {
        invalidEmails.push(em)
      } else {
        validEmails.push(em)
      }
    }

    const errorMsg = invalidEmails.length > 0
      ? i18n.t(`${BASE_KEY}.invalidEmail`, { row: row, email: invalidEmails.join(', ') })
      : ''
    result.push({
      filename,
      emails: invalidEmails.length > 0 ? [] : validEmails,
      errorMsg
    })
  }

  return result
}
